import React from "react"
import { subtitleBox } from "./layout"

/** Page text positioned from the authored renderBox, scaled to the viewport. */
export default function Subtitles({ page, viewport, visible }) {
  const box = subtitleBox(viewport, page)
  if (!box || !visible) return null
  const comics = box.textFrame === "comics"
  return (
    <div
      data-testid="player-subtitles"
      className="absolute rounded-lg px-4 py-3 leading-snug shadow-lg"
      style={{
        left: box.left,
        top: box.top,
        width: box.width,
        color: box.color,
        fontSize: box.fontSize,
        textAlign: box.alignment,
        fontFamily: "'Gentium Book Plus', Georgia, serif",
        backgroundColor: comics ? "#fff" : "rgba(255,255,255,0.92)",
        border: comics ? "1px solid #000" : "none",
      }}
    >
      {box.text.split("\n").map((line, i) => (
        <div key={i}>{line || " "}</div>
      ))}
    </div>
  )
}
